function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './resource-list.scss';
import template from './resource-list.html';

export var ResourceListComponent = {
  template: template,
  styles: styles,
  bindings: {
    resourceData: "<",
    onSelect: "&" },

  controller: /*#__PURE__*/function () {ResourceListComponentController.$inject = ["$scope", "$sce"];
    function ResourceListComponentController($scope, $sce) {
      "ngInject";_classCallCheck(this, ResourceListComponentController);
      console.log(this);
      this.$scope = $scope;
      this.dataIsLoaded = false;
      this.$sce = $sce;
    }_createClass(ResourceListComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this = this;
        this.onSelectItem = function (item) {return _this.onSelect({ item: item });};
        this.swiperOptoins = {
          // slidesOffsetBefore: 23,
          // slidesOffsetAfter: 23,
          centeredSlides: false,
          freeMode: true
          // breakpoints: {
          //   1199: {
          //     slidesOffsetBefore: 10,
          //     slidesOffsetAfter: 10,
          //   }
          // }
        };
      } }, { key: "$doCheck", value: function $doCheck()

      {
        if (!this.dataIsLoaded && this.resourceData.length) {
          this.dataIsLoaded = true;
          this.swiperOptoins = {
            // slidesOffsetBefore: 23,
            // slidesOffsetAfter: 23,
            centeredSlides: false,
            freeMode: true
            // breakpoints: {
            //   1199: {
            //     slidesOffsetBefore: 10,
            //     slidesOffsetAfter: 10,
            //   }
            // }
          };
        }
      } }]);return ResourceListComponentController;}() };